'use es6';

import I18n from 'I18n';
import { connect } from 'react-redux';
import { useState, useMemo } from 'react';
import { getFlattenedCustomObjects } from 'FormsUI/selectors/customObjects';
import OptionsTable from 'ui-forms-components/options/OptionsTable';
import OptionsTableFooter from 'ui-forms-components/options/OptionsTableFooter';
import AvailableOptionsToggle from 'ui-forms-components/options/AvailableOptionsToggle';
import AvailableOptionsModal from 'ui-forms-components/options/AvailableOptionsModal';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import { calculateUnusedOptions, getOptionsToAdd, getRouteFromField } from 'FormsUI/utils/OptionsTable';
import { Spacer } from 'foundations-components/components/Spacer';
import { Alert } from 'foundations-components/transitional/components/Alert';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConfigurationPropertyOptionsTableWrapper = ({
  formField,
  flattenedObjects,
  handleUpdate
}) => {
  const [showAllOptions, setShowAllOptions] = useState(false);
  const [isModalShown, setIsModalShown] = useState(false);
  const [isAddMoreShown, setIsAddMoreShown] = useState(false);
  const unusedOptions = calculateUnusedOptions(flattenedObjects, formField);
  const hasInvalidOptions = useMemo(() => formField.options.some(option => !option.value || option.value.length === 0), [formField]);
  if (isAddMoreShown !== !!unusedOptions.length) setIsAddMoreShown(!!unusedOptions.length);
  return /*#__PURE__*/_jsx(CommentableArea, {
    moduleId: `${getPropertyObjectTypeId(formField)}-options-table`,
    description: {
      translationKey: 'formsPropertyOptions'
    },
    children: /*#__PURE__*/_jsx("div", {
      "data-test-id": "config-input-field",
      children: /*#__PURE__*/_jsx(FormControl, {
        help: /*#__PURE__*/_jsx(Link, {
          external: true,
          href: getRouteFromField(formField),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'editor.form.config.editPropertyOptions'
          })
        }),
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'editor.form.config.propertyOptions'
        }),
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(OptionsTable, {
            formField: formField,
            handleUpdate: handleUpdate,
            handleOnDrag: () => setShowAllOptions(true),
            showAllOptions: showAllOptions,
            use: "light",
            hasOwnDragLayer: true
          }), /*#__PURE__*/_jsx(OptionsTableFooter, {
            formField: formField,
            optionsLength: formField.options.length,
            shouldShowMore: true,
            shouldShowLess: showAllOptions,
            shouldShowClear: formField.selectedOptions.length > 0,
            handleUpdate: handleUpdate,
            toggleShowMore: () => setShowAllOptions(!showAllOptions)
          }), hasInvalidOptions && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(Alert, {
              type: "warning",
              titleText: I18n.text('editor.form.config.validation.emptyValues.title'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "editor.form.config.validation.emptyValues.description"
              })
            })]
          }), isAddMoreShown && /*#__PURE__*/_jsx(View, {
            paddingBlockStart: "300",
            paddingBlockEnd: "300",
            as: "div",
            children: /*#__PURE__*/_jsx(CardWrapper, {
              compact: true,
              children: /*#__PURE__*/_jsx(CardSection, {
                children: /*#__PURE__*/_jsx(AvailableOptionsToggle, {
                  disabled: false,
                  toggleModal: () => setIsModalShown(true)
                })
              })
            })
          }), isModalShown && /*#__PURE__*/_jsx(AvailableOptionsModal, {
            link: getRouteFromField(formField),
            options: unusedOptions,
            addSelectedOptions: newOptions => {
              handleUpdate(updateFormFieldKey(formField, FormFieldKeys.OPTIONS, [...formField.options, ...getOptionsToAdd(flattenedObjects, formField, newOptions)]));
              setIsModalShown(false);
            },
            closeModal: () => setIsModalShown(false)
          })]
        })
      })
    })
  });
};
const mapStateToProps = state => ({
  flattenedObjects: getFlattenedCustomObjects(state)
});
const actionCreators = {};
export default connect(mapStateToProps, actionCreators)(ConfigurationPropertyOptionsTableWrapper);